import React, { useEffect, useState } from 'react';



import { urlWebsite } from '../../../../../../../config';

import ParagraphDangerous from '../../../../../../../components/UIComponents/ParagraphDangerous';

import { useModal } from '../../../../../../../hooks/Modal';
import { FaClock } from 'react-icons/fa';
import { date, hour, simpleDateBR, simpleDateUS } from 'src/utils/date';
import { useLanguage } from 'src/hooks/Language';

interface IProps {
    list: Record<string, any>;
}

const ProgramWidget: React.FC<IProps> = ({ list }) => {

    const { language } = useLanguage();
    const [items, setItems] = useState<JSX.Element[]>([])

    const [program, setProgram] = useState([]);

    const [filters, setFilters] = useState<Record<string, any>[]>([]);
    const [filter, setFilter] = useState('');

    const applyFilter = (value, current) => {
        if (current === value) {
            setFilter('');
        }
        else {
            setFilter(value)
        }

        window?.scrollTo(0, 0)
    }

    useEffect(() => {

        const filtersList: Record<string, any>[] = [];

        {
            list?.map(
                (line) => {
                    line?.program?.map(block => {

                        const dateInfo = simpleDateBR(block?.start_at);
                        const dateInfoUS = simpleDateUS(block?.start_at);

                        const index = filtersList?.findIndex(i => i?.date === dateInfoUS);

                        if (index < 0) {
                            filtersList.push({ title: dateInfo, title_en: dateInfoUS, title_es: dateInfo, date: dateInfoUS });
                        }

                    })


                })
        }
        setFilters(filtersList)




    }, [list])

    const reduceList = (listItems, dateFilter) => {
        console.log(listItems, dateFilter)
        const items: Record<string, any>[] = [];

        listItems.map(line => {


            const count = line?.program?.filter(i => {
                const date = simpleDateUS(i?.start_at);
                console.log(date, dateFilter)
                return date === dateFilter;
            })?.length;

            if (count > 0) {
                items?.push(line);
            }

        })


        return items;


    }

    const completeList = !filter ? list : reduceList(list, filter);


    return (<>



        <div className='full-width column gap' style={{ width: '100%', padding: '0px', }}>
            <div className='row-start gap full-width' style={{ paddingBottom: '15px', borderBottom: '2px solid #fff', }}>
                {filters?.map(
                    (line) => {
                        return <button onClick={() => applyFilter(line?.title_en, filter)} className={filter === line?.title ? 'greenButton2' : 'greenButton2'} style={{
                            color: filter === line?.title_en ? '#fff' : '#162743',
                            background: filter === line?.title_en ? '#162743' : '#fff'

                        }}>{line?.[`title_${language}`] ? line?.[`title_${language}`] : line?.title}</button>
                    })}


            </div>


            {completeList?.map(
                (line: Record<string, any>) => {


                    return <div className='column-start full-width'>
                        {line?.title ? <h2>{line?.title}</h2> : <></>}
                        {line?.description ? <p dangerouslySetInnerHTML={{ __html: line?.description }} /> : <></>}
                        {line?.type === 'line' ? <div className='column-start gap-sm' style={{ paddingTop: '15px' }}>
                            {line?.program?.map((block: Record<string, any>) => <div className='column-start'>
                                {block?.start_at ? <div className='row-start' style={{ gap: '5px', padding: '10px 0px' }}><FaClock style={{ fontSize: '18px' }} /> {hour(block?.start_at, language)} {block?.end_at ? ` - ${hour(block?.end_at, language)}` : <></>} </div> : <></>}
                                {block?.image ? <img src={`${urlWebsite}/${block?.image}`} style={{ minWidth: '25px', width: '25px' }} /> : <></>}



                                {block?.rows?.map((item) => {
                                    return <div className='row' style={{ background: 'none', padding: '10px 0px', gap: '5px', alignItems: 'center', justifyContent: 'flex-start' }}>
                                        {item?.image ? <img src={`${urlWebsite}/${item?.image}`} style={{ minWidth: '25px', width: '25px' }} /> : <></>}
                                        {item?.title ? <p dangerouslySetInnerHTML={{ __html: item?.title }} /> : <></>}
                                        {item?.image2 ? <img src={`${urlWebsite}/${item?.image2}`} style={{ minWidth: '25px', width: '25px' }} /> : <></>}

                                    </div>

                                })}

                            </div>)}
                        </div> : <></>}


                        {line?.type === 'table' || !line?.type ? <table className='tableRef2' style={{ width: '100%', paddingTop: '15px', marginTop: '15px' }}>
                            <tbody>
                                {line?.program?.map((block: Record<string, any>) => {

                                    return <tr>

                                        {block?.start_at || block?.end_at || block?.image ? <td style={{ minWidth: '150px', width: '150px' }}>

                                            {block?.start_at ? <div className='row-start' style={{ gap: '5px', padding: '10px 0px' }}><FaClock style={{ fontSize: '18px', minWidth: '20px' }} /> {hour(block?.start_at, language)} {block?.end_at ? ` - ${hour(block?.end_at, language)}` : <></>} </div> : <></>}
                                            {block?.image ? <div className='full-width column'><img src={`${urlWebsite}/${block?.image}`} style={{ minWidth: '60px', margin: '0px auto', width: '60px' }} /></div> : <></>}

                                        </td> : <></>}

                                        <td colSpan={block?.start_at || block?.end_at || block?.image ? 1 : 2}>

                                            {block?.rows?.map((item) => {
                                                return <div className='row' style={{ background: 'none', padding: '10px 0px', gap: '5px', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                    {item?.image ? <img src={`${urlWebsite}/${item?.image}`} style={{ minWidth: '25px', width: '25px' }} /> : <></>}
                                                    {item?.title ? <p dangerouslySetInnerHTML={{ __html: item?.title }} /> : <></>}
                                                    {item?.image2 ? <img src={`${urlWebsite}/${item?.image2}`} style={{ minWidth: '25px', width: '25px' }} /> : <></>}

                                                </div>

                                            })}

                                        </td>


                                    </tr>

                                })}

                            </tbody>


                        </table> : <></>}

                    </div>

                }

            )}





        </div>

    </>);
};
export default ProgramWidget;
